var exports = {
  "iE": "xaee3c4fa--17ddcb--wrapper",
  "Pf": "xaee3c4fa--17ddcb--label",
  "mw": "xaee3c4fa--17ddcb--required",
  "ko": "xaee3c4fa--17ddcb--strong",
  "Pl": "xaee3c4fa--17ddcb--after",
};

module.exports = exports;
